module.exports = __webpack_public_path__ + "static/media/RMIT-FULL-WHITE.4d8d3f45.svg";